var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLocationPin = function SvgLocationPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#636363",
    d: "M12.266 1.5c4.27 0 7.743 3.473 7.743 7.743 0 2.302-1.257 5.145-3.36 8.292a44.489 44.489 0 0 1-2.336 3.17l-.323.396c-.256.312-.481.577-.666.789l-.201.228c-.458.51-1.257.51-1.715 0l-.316-.361c-.16-.187-.346-.406-.551-.656l-.322-.396a44.498 44.498 0 0 1-2.337-3.17c-2.102-3.147-3.36-5.99-3.36-8.292 0-4.27 3.474-7.743 7.744-7.743zm0 2.304a5.446 5.446 0 0 0-5.44 5.44c0 2.474 2.184 6.291 5.166 9.987l.274.336.273-.336.533-.673c2.707-3.481 4.632-6.99 4.632-9.315a5.446 5.446 0 0 0-5.438-5.439zm0 2.192c1.79 0 3.247 1.456 3.247 3.247s-1.457 3.248-3.247 3.248a3.252 3.252 0 0 1-3.248-3.248 3.251 3.251 0 0 1 3.248-3.247zm0 1.806c-.795 0-1.442.647-1.442 1.441 0 .795.647 1.442 1.442 1.442.794 0 1.441-.647 1.441-1.442 0-.794-.647-1.441-1.441-1.441z"
  })));
};

export default SvgLocationPin;